import React from 'react';

import { LinearProgress } from '@mui/material';

const ApplicationLoading = () => {
  return <LinearProgress color="secondary" />;
};

export default ApplicationLoading;
